import { Card, CardContent, CardHeader, Grid, IconButton } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { FormTextField, HiddenField } from 'shared/controls';
import { TPdfCustomProductForm } from 'shared/types';
import { buildCustomProductFieldNameWithIndex } from 'shared/utility';

interface IPdfCustomProductFieldsProps {
  customProduct: TPdfCustomProductForm;
  index: number;
  moveUp(): void;
  moveDown(): void;
  disableMoveUp: boolean;
  disableMoveDown: boolean;
}
export function PdfCustomProductFields({
  index,
  moveDown,
  moveUp,
  disableMoveDown: disableBottom,
  disableMoveUp: disableTop,
}: IPdfCustomProductFieldsProps) {
  const buildFieldName = buildCustomProductFieldNameWithIndex<TPdfCustomProductForm>(index);

  return (
    <Grid item xs={12}>
      <Card elevation={2}>
        <CardHeader
          action={
            <>
              <IconButton disabled={disableBottom} onClick={moveDown}>
                <ArrowDownward />
              </IconButton>
              <IconButton disabled={disableTop} onClick={moveUp}>
                <ArrowUpward />
              </IconButton>
            </>
          }
        />
        <CardContent>
          <Grid container spacing={1} justifyContent='center' alignItems='center'>
            <Grid item container spacing={1}>
              <Grid item xs={12} md={4}>
                <FormTextField label='Product' name={buildFieldName('customProductName')} />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                label='Line Item Notes'
                name={buildFieldName('notes')}
                readOnly={false}
                multiline
                minRows={3}
                maxRows={10}
                fullWidth
              />
            </Grid>
          </Grid>
          <HiddenField name={buildFieldName('customProductQuantity')} />
          <HiddenField name={buildFieldName('customProductPrice')} />
        </CardContent>
      </Card>
    </Grid>
  );
}
